/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelEnumInterfaces.mustache
// synched 02.02.2023
import * as yup from 'yup';
import * as fastJSON from 'fast-json-stringify';
import { StringSchema } from 'fast-json-stringify';
/**
 * The possible arithmetic operations that can be done between multiple tags.
 * @export
 * @enum {string}
 */
export enum TagArithmeticsOperation {
    UNION = 'UNION',
    INTERSECTION = 'INTERSECTION',
    DIFFERENCE = 'DIFFERENCE'
}
/* LIGHTLY CUSTOM START -> modelEnumInterfaces */
export const TagArithmeticsOperationValidatorShape = [
    'UNION',
    'INTERSECTION',
    'DIFFERENCE'
];
export const TagArithmeticsOperationValidator = yup.mixed().oneOf(TagArithmeticsOperationValidatorShape);
export const TagArithmeticsOperationStringifyShapeProperties = {};
export const TagArithmeticsOperationStringifyShape: StringSchema = {
    title: 'TagArithmeticsOperation Stringifier',
    type: 'string'
};
export const TagArithmeticsOperationStringify = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(TagArithmeticsOperationStringifyShape)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
/* LIGHTLY CUSTOM END */
export function TagArithmeticsOperationFromJSON(json: any): TagArithmeticsOperation {
    return TagArithmeticsOperationFromJSONTyped(json, false);
}
export function TagArithmeticsOperationFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagArithmeticsOperation {
    return json as TagArithmeticsOperation;
}
export function TagArithmeticsOperationToJSON(value?: TagArithmeticsOperation | null): any {
    return value as any;
}
